import type { MessageAttachment } from '@/types/conversations'
import { resolveAttachmentMediaUrl } from '@/lib/resolveAttachmentMediaUrl'

import type { AttachmentContext } from './attachmentContext'

interface DocumentAttachmentProps {
  attachment: MessageAttachment
  attachmentContext?: AttachmentContext
}

export function DocumentAttachment({
  attachment,
  attachmentContext = 'assistant',
}: DocumentAttachmentProps) {
  const href = resolveAttachmentMediaUrl(attachment.file_url) || '#'
  const ext = attachment.filename?.split('.').pop()?.toUpperCase() || 'FILE'
  const showAiDescription =
    attachmentContext === 'assistant' && Boolean(attachment.ai_description?.trim())

  return (
    <a
      href={href}
      download={attachment.filename}
      target="_blank"
      rel="noopener noreferrer"
      className="flex max-w-full min-w-0 items-start gap-2 rounded-md border bg-muted/30 p-3 transition-colors hover:bg-muted/50 sm:min-w-[220px]"
    >
      <span className="shrink-0 text-2xl">📄</span>
      <div className="min-w-0 flex-1 overflow-hidden">
        <p className="break-all text-sm font-medium leading-snug">
          {attachment.filename || 'Documento'}
        </p>
        <p className="text-xs text-muted-foreground">{ext}</p>
        {showAiDescription ? (
          <p className="mt-1 truncate text-xs italic text-muted-foreground">
            {attachment.ai_description}
          </p>
        ) : null}
      </div>
    </a>
  )
}
